

import React,{Component} from "react";
import { inject, observer } from 'mobx-react';

import GridContainer from "../../components/Grid/GridContainer.jsx";
import ItemGrid      from "../../components/Grid/ItemGrid.jsx";

import { withStyles } from "material-ui";
import appStyle from "../../assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";


import IconCard from "../../components/Cards/IconCard";
import PhotoIcon from '@material-ui/icons/Photo';
import DateRangeIcon from '@material-ui/icons/DateRange';

import Cookies from "universal-cookie";
const cookies = new Cookies();


@inject('store')
@observer
class Home extends Component {


    render() {

        const project_id = cookies.get('project_id');
        const project_name = cookies.get('project_name');
        const {classes}=this.props;

        return(
            <React.Fragment>
                <GridContainer justify='center'>
                    <ItemGrid xs={10} sm={10} md={10}>
                        <h2 style={{textAlign: "center"}}>{project_id} - {project_name}</h2>
                    </ItemGrid>
                </GridContainer>
                <GridContainer justify='center'>
                    <ItemGrid xs={6} sm={4} md={4}>
                        <div onClick={() => this.props.history.push('/album-configuration')} style={{cursor: 'pointer'}}>
                            <IconCard
                                icon={PhotoIcon}
                                iconColor="rose"
                                content={
                                    <p className={classes.paragraph_center}>Album</p>
                                }
                            />
                        </div>
                    </ItemGrid>
                    <ItemGrid xs={6} sm={4} md={4}>
                        <div onClick={() => this.props.history.push('home-calendar')} style={{cursor: 'pointer'}}>
                            <IconCard
                                icon={DateRangeIcon}
                                iconColor="rose"
                                content={
                                    <p className={classes.paragraph_center}>
                                        Calendario
                                    </p>
                                }
                            />
                        </div>
                    </ItemGrid>

                </GridContainer>
            </React.Fragment>
        )
    }
}

export default withStyles(appStyle)(Home);



// WEBPACK FOOTER //
// ./src/views/Home/Home.jsx